(function () {
  function initMediaTabs(tabBar) {
    var galleryId = tabBar.getAttribute('data-gallery-target');
    var gallery = galleryId ? document.getElementById(galleryId) : tabBar.nextElementSibling;
    if (!gallery) return;
    if (gallery.dataset.mediaTabsInit === 'true') return;
    gallery.dataset.mediaTabsInit = 'true';

    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    items.forEach(function (item) {
      var isVideo = !!item.querySelector('video, iframe, deferred-media, product-model');
      item.dataset.mediaKind = isVideo ? 'video' : 'image';
    });

    var thumbsAndDots = Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list__item, .dot-navigation-dot')
    );
    thumbsAndDots.forEach(function (control) {
      var targetId = control.getAttribute('data-target');
      if (!targetId) return;
      var mediaItem = gallery.querySelector('#Slide-' + targetId);
      if (mediaItem) {
        control.dataset.mediaKind = mediaItem.dataset.mediaKind;
      }
    });

    function activate(kind) {
      tabBar.querySelectorAll('[data-media-tab]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.mediaTab === kind);
      });

      var firstVisibleItem = null;

      items.forEach(function (item) {
        var visible = kind === 'videos'
          ? item.dataset.mediaKind === 'video'
          : item.dataset.mediaKind !== 'video';
        item.classList.toggle('media-tab-hidden', !visible);
        if (visible && !firstVisibleItem) firstVisibleItem = item;
      });

      thumbsAndDots.forEach(function (control) {
        var visible = kind === 'videos'
          ? control.dataset.mediaKind === 'video'
          : control.dataset.mediaKind !== 'video';
        control.classList.toggle('media-tab-hidden', !visible);
      });

      if (firstVisibleItem) {
        var targetId = firstVisibleItem.id.replace('Slide-', '');
        var jumpControl = gallery.querySelector(
          '.thumbnail-list__item[data-target="' + targetId + '"] button, ' +
          '.dot-navigation-dot[data-target="' + targetId + '"]'
        );
        if (jumpControl) {
          jumpControl.click();
        } else {
          firstVisibleItem.scrollIntoView({ inline: 'start', block: 'nearest' });
        }

        if (kind === 'videos') {
          var posterBtn = firstVisibleItem.querySelector('.deferred-media__poster');
          if (posterBtn) {
            setTimeout(function () {
              posterBtn.click();
            }, 50);
          }
        }
      }
    }

    tabBar.querySelectorAll('[data-media-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.dataset.mediaTab);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-media-tabs]').forEach(initMediaTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
